import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Box, Text } from '@hub-la/design-system';
import { useFormik, FormikProvider } from 'formik';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { PermissionResource } from '../../../domain/dtos/permissions-resources-enum.js';
import { CollaboratorForm } from '../../components/collaborator-form.js';
import { useGetCollaborator } from '../../hooks/use-get-collaborator.js';
import { usePutCollaborator } from '../../hooks/use-put-collaborator.js';
import { createCollaboratorSchema } from '../../validations/create-collaborator.schema.js';

const EditCollaboratorPage = () => {
  var _a, _b, _c;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const params = useParams();
  const {
    data
  } = useGetCollaborator(params.id);
  const {
    mutateAsync,
    isLoading
  } = usePutCollaborator({
    onSuccess: () => {
      history.push('/collaborators');
    }
  });
  const formik = useFormik({
    validationSchema: createCollaboratorSchema,
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    initialValues: {
      name: (_a = data === null || data === void 0 ? void 0 : data.name) !== null && _a !== void 0 ? _a : '',
      email: (_b = data === null || data === void 0 ? void 0 : data.email) !== null && _b !== void 0 ? _b : '',
      permissions: (_c = data === null || data === void 0 ? void 0 : data.permissions) !== null && _c !== void 0 ? _c : []
    },
    onSubmit: values => __awaiter(void 0, void 0, void 0, function* () {
      yield mutateAsync({
        collaboratorUserId: params.id,
        permissions: values.permissions
      });
    })
  });
  return jsx(FormikProvider, Object.assign({
    value: formik
  }, {
    children: jsxs(Box, Object.assign({
      maxWidth: 588,
      mx: "auto",
      mt: 8,
      mb: 8
    }, {
      children: [jsxs(Text, Object.assign({
        variant: "h3",
        mb: 3
      }, {
        children: [t('editCollaborator.title'), " ", PermissionResource[PermissionResource.HOME_ABANDONED_CHECKOUT]]
      })), jsx(Text, Object.assign({
        variant: "body2",
        mb: 6
      }, {
        children: t('editCollaborator.description')
      })), jsx(CollaboratorForm, {
        isEdit: true,
        loading: isLoading
      })]
    }))
  }));
};

export { EditCollaboratorPage };
